import { FC } from 'react';

interface ReportContentsInfoProps {
    contentsNum: number;
    selectedThumbContent?: DATA.MdulEvlInfo | EvlInfo;
    submAt?: FlagYn;
    articleType?: number;
}

export const ContentsInfo: FC<ReportContentsInfoProps> = ({
    contentsNum,
    selectedThumbContent,
    submAt,
    articleType,
}) => {
    const typeHandler = (item?: DATA.MdulEvlInfo | EvlInfo) => {
        if (item) return 'mdulEvlInfo' in item ? item.mdulItemInfo : item;
    };
    const filteredContent = typeHandler(selectedThumbContent);
    const submAtLabelVal = submAt === 'Y' ? '제출' : '미제출';
    const scoreNum = submAt === 'Y' ? (filteredContent?.evlIemScr ?? '-') : '-';

    return (
        <div className="cont-info">
            <strong className="title">[{contentsNum}번 콘텐츠] 원본</strong>
            <dl>
                <dt>제출 여부</dt>
                <dd>{submAtLabelVal}</dd>
                <dt>배점</dt>
                {articleType === 20 ? <dd>-</dd> : <dd>{scoreNum}</dd>}
                <dt>정오표</dt>
                <dd>-</dd>
            </dl>
        </div>
    );
};
